export const CALCULATOR_SECTION_ID = 'calculate-price';
